import styled from "styled-components";

export const PageContainer = styled.div`
    padding: 24px;

    @media (max-width: 768px) {
        padding: 12px 8px;
    }
`;

export const HeaderSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
        margin-bottom: 16px;
    }
`;

export const PageTitle = styled.h2`
    margin: 0;
    font-size: 1.5em;

    @media (max-width: 768px) {
        font-size: 1.1em;
        line-height: 1.3;
    }
`;

export const MapContainer = styled.div`
    width: 100%;
    height: 550px;
    margin-bottom: 32px;

    @media (max-width: 768px) {
        height: 350px;
        margin-bottom: 20px;
    }
`;

export const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    ${props => props.$marginTop ? `margin-top: ${props.$marginTop}px;` : ""}

    @media (max-width: 768px) {
        margin-bottom: 6px;
        ${props => props.$marginTop ? `margin-top: ${Math.round(props.$marginTop * 0.65)}px;` : ""}
    }
`;

export const SectionColorIndicator = styled.span`
    width: 16px;
    height: 16px;
    margin-right: 8px;
    flex-shrink: 0;
    background-color: ${props => props.color};

    @media (max-width: 768px) {
        width: 14px;
        height: 14px;
    }
`;

export const SectionTitle = styled.h3`
    margin-bottom: 0;

    @media (max-width: 768px) {
        font-size: 14px;
    }
`;

export const LegendWrapper = styled.div`
    display: flex;
    gap: 16px;
    margin-bottom: 12px;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    @media (max-width: 768px) {
        gap: 8px;
        margin-bottom: 10px;
    }
`;

export const LegendList = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

    @media (max-width: 768px) {
        flex-wrap: wrap;
        gap: 6px;
    }
`;

export const LegendItem = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    user-select: none;

    @media (max-width: 768px) {
        font-size: 12px;
        gap: 4px;
    }
`;

export const ColorBox = styled.span`
    width: 18px;
    height: 18px;
    display: inline-block;
    border-radius: 4px;
    border: 1px solid #ccc;
    background-color: ${props => props.color};

    @media (max-width: 768px) {
        width: 14px;
        height: 14px;
    }
`;

// FilterModal component styles
export const ModalTitle = styled.div`
    font-weight: 700;
    font-size: 20px;
    letter-spacing: 0.2px;
`;

export const ModalBodyWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 18px 24px;
    border-bottom: 1px solid #f0f0f0;
    background: #f8fafc;
`;

export const SwitchLabel = styled.label`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 500;
    color: ${props => (props.checked ? (props.unknown ? "#888" : "#1976D2") : "#7a8ca6")};
`;

export const FilterModalContentWrapper = styled.div`
    padding: 12px 24px 0 24px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: 60vh;
    overflow-y: auto;
`;

export const SearchInput = styled.input`
    width: 100%;
    margin-bottom: 0;
    padding: 10px;
    border-radius: 7px;
    border: 1px solid #e0e0e0;
    font-size: 15px;
    background: #fafbfc;
`;

export const ListSection = styled.div`
    background: #fff;
    border-radius: 0;
    padding: 0;
    box-shadow: none;
    margin-bottom: 0;
`;

export const ListHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 16px 0 2px 0;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 2px;
`;

export const ListTitle = styled.span`
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 0.1px;
    color: ${props => props.color || "#1976D2"};
`;

export const ListItemLabel = styled.label`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 0;
    cursor: pointer;
    border-bottom: ${props => (props.isLast ? "none" : "1px solid #f0f0f0")};
    background: none;
    font-size: 14px;
    min-height: 30px;
    transition: background 0.2s;
    &:hover {
        background: #f6f8fa;
    }
`;

export const ItemColorIndicator = styled.span`
    width: 13px;
    height: 13px;
    border-radius: 3px;
    background: ${props => props.color};
    display: inline-block;
    margin-left: 4px;
    border: 1px solid #e0e0e0;
`;

export const NoResultSpan = styled.span`
    color: #b0b8c9;
    font-size: 14px;
    display: block;
    padding: 12px;
`;

export const FixedBottomBar = styled.div`
    width: 100%;
    height: 80px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    border-top: 1px solid #f0f0f0;
`;

export const ButtonWrapper = styled.div`
    position: absolute;
    right: 32px;
    bottom: 24px;
`;
